import { getMeasurements } from '@/reducers/selectors'
import withEditableWidget from '@/components/DashboardPageV2/Desktop/Widgets/Shared/HOC/withEditableWidget'
import { MeasurementEdit } from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Measurement'

import DatasetLine from './DatasetLine'
import { getMeasurementUnit } from '@/components/DashboardPageV2/utils'

function MeasureByDepthView(props) {
  const { config, options } = props

  const measurements = getMeasurements()

  const unit = getMeasurementUnit(measurements, options.measurement)

  return (
    <DatasetLine unit={unit} config={config} options={options} {...props} />
  )
}

export const MeasureByDepthWidget = withEditableWidget(
  MeasureByDepthView,
  MeasurementEdit
)
